import { animeList, dayTabs } from "@/mocks/anime";
import { siteStats } from "@/mocks/ranking";

const weekDays = dayTabs.filter((day) => day !== "全部");

export default function About() {
  const distribution = weekDays.map((day) => ({
    day,
    count: animeList.filter((item) => item.day === day).length,
  }));
  const maxCount = Math.max(...distribution.map((item) => item.count));

  return (
    <section id="about" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="text-sm font-medium text-primary-600">关于本站</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
              一个专注新番信息梳理的单页导航站
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              樱花动漫在线的出发点是让「追新番」这件事更省心。当季作品数量多、档期分散，观众常常要反复确认某部作品今天是否更新、更新到第几话、还差多少话完结。本站用统一的条目结构把这些信息集中呈现，减少来回查找的成本。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              页面从上到下依次呼应追番的常见顺序：先看本季推荐，再确认本周排期，接着浏览最新话看点，最后用分类检索锁定目标。所有筛选与展开都在本页完成，不需要跳转到其他页面。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
              {siteStats.map((stat) => (
                <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <p className="font-heading text-2xl text-primary-700">
                    {stat.value}
                    <span className="ml-1 text-sm text-foreground-700">{stat.unit}</span>
                  </p>
                  <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <h3 className="font-heading text-lg text-foreground-950">一周期播出分布</h3>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">
              下图为本站收录作品在周一至周日的数量分布，可以看出周末档期相对集中，适合集中补番。
            </p>
            <div className="mt-6 space-y-4">
              {distribution.map((item) => (
                <div key={item.day} className="flex items-center gap-3">
                  <span className="w-10 shrink-0 text-xs text-foreground-700">{item.day}</span>
                  <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${(item.count / maxCount) * 100}%` }}
                    ></div>
                  </div>
                  <span className="w-6 shrink-0 text-right text-xs text-foreground-700">{item.count}</span>
                </div>
              ))}
            </div>
            <div className="mt-6 rounded-lg bg-secondary-100 p-4">
              <p className="flex items-center gap-2 text-sm font-medium text-secondary-900">
                <i className="ri-information-line"></i>
                数据说明
              </p>
              <p className="mt-2 text-xs leading-relaxed text-secondary-900/85">
                页面中的条目、评分、追番人数与排期均为整理后的展示内容，用于辅助了解当季新番的整体情况，具体播出时间与集数以官方公布为准。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}